import { useMutation } from '@tanstack/react-query';
import useGlynt from './useGlynt';
import { IRQCallbacks, ITrainingSetCreate } from '../../types/my-types';

export const useCreateTrainingSet = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: ITrainingSetCreate) => await (await glynt).trainingSet.create(data),
    ...callbacks
  });
};
